import { deleteDoc, doc } from "firebase/firestore";
import FirebaseConfig from "../../config/firebase";

export default async (uid: string) => {
  const voucherRef = doc(FirebaseConfig.db, "vouchers", uid);
  await deleteDoc(voucherRef);
};
